import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { Loading } from '@liveauctioneers/hammer-ui-core/loading';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import { RouteLink } from '@/components/RouteLinks/RouteLinks';
import { useAppSelector } from '@/redux/hooks';
import { getCatalogTitle } from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { getLiveCatalogStatus } from '@/redux/modules/console';
import {
    getItemSummaryFirstImageUrl,
    getItemSummaryTitle,
    getItemSummaryUrl,
} from '@/redux/modules/item/summary/itemSummary.selectors';
import { addImageParams } from '@/utils/urls';

type Props = {
    catalogId: number;
    className?: string;
    imageWidth?: number;
    itemId: number;
    showLive: boolean;
};

const CurrentItemLinkComponent = ({ catalogId, className, imageWidth = 375, itemId, showLive }: Props) => {
    const catalogTitle = useAppSelector((state) => getCatalogTitle(state, catalogId));
    const liveCatalogStatus = useAppSelector((state) => getLiveCatalogStatus(state, catalogId));
    const title = useAppSelector((state) => getItemSummaryTitle(state, itemId));
    const itemUrl = useAppSelector((state) => getItemSummaryUrl(state, itemId));

    const saleFinished = liveCatalogStatus === 'done';
    const saleLive = liveCatalogStatus === 'live' || liveCatalogStatus === 'paused' || showLive;

    const firstPhoto = useAppSelector((state) => getItemSummaryFirstImageUrl(state, itemId));
    const imageUrl = addImageParams({ url: firstPhoto, width: imageWidth });

    return (
        <RouteLink
            className={cn('flex h-full cursor-pointer items-center justify-center', className)}
            to={itemUrl}
        >
            <img
                alt={title}
                className="relative z-[1] max-h-full max-w-full"
                src={imageUrl}
            />
            {!saleLive && (
                <div className="absolute top-1/2 z-[2] w-[calc(100%-20px)] rounded-sm bg-background-primary p-sm text-center text-xl shadow-[0_0_10px_rgba(0,0,0,0.3)]">
                    {saleFinished ? (
                        <FormattedMessage
                            id="bidding_console.done.title"
                            values={{ title: catalogTitle }}
                        />
                    ) : (
                        <>
                            <FormattedMessage id="bidding_console.wait.title" />
                            <Loading />
                        </>
                    )}
                </div>
            )}
        </RouteLink>
    );
};

export const CurrentItemLink = CurrentItemLinkComponent;
